export default "__VITE_ASSET__zLzmC7p5__"